<mat-sidenav-container autosize>

  <mat-sidenav [ngStyle]="{ width: (srv.openState$ | async) ? '200px' : '53px' }" fixedInViewport="true" mode="side"
    opened>
    <ng-container *ngIf="srv.openState$ | async then openTmpl; else closedTmpl"></ng-container>

    <!-- OPEN -->
    <ng-template #openTmpl>
      <div id="open">
        <div class="logo">
          <img i18n-title src="../../assets/centrak.svg" title="CenTrak" />
        </div>

        <mat-nav-list *ngIf="srv.appSwitcherVisible$" class="wrapped-list">
          <mat-list-item>
            <div [matMenuTriggerFor]="appSwitcherMenu" class="item-content">
              <mat-icon>apps</mat-icon>
              <span [title]="products['Integrate']" class="mat-body-strong">{{ products['Integrate'] }}</span>
            </div>
          </mat-list-item>
        </mat-nav-list>

        <mat-nav-list>
          <a mat-list-item routerLink="/messages" routerLinkActive="active">
            <div class="item-content">
              <mat-icon>list_alt</mat-icon>
              <span class="mat-body-strong" i18n i18n-title title="Messages">Messages</span>
            </div>
          </a>
        </mat-nav-list>

        <div style="flex: 1"></div>

        <mat-nav-list class="wrapped-list">
          <mat-list-item (click)="openNotification()">
            <div class="item-content">
              <mat-icon>notifications</mat-icon>
              <span
                class="mat-body-strong"
                i18n
                i18n-title style="position: static;"
                title="Notifications"
              >Notifications</span>
              <div *ngIf="hasNotifications$ | async" class="visual-indicator">
                <div></div>
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>

        <div class="legal">
          <p class="mat-caption">
            <span>&copy; {{ year }} CenTrak, Inc.</span> <br />
            <span i18n>All rights reserved.</span>
          </p>
          <button (click)="srv.toggleState()" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>
    <!-- / OPEN -->

    <!-- CLOSED -->
    <ng-template #closedTmpl>
      <div id="closed">
        <div class="logo" i18n-matTooltip matTooltip="{{products['Integrate']}} ({{version}})">
          <img i18n-title src="../../assets/iso.svg" title="CenTrak" />
        </div>

        <mat-nav-list class="wrapped-list">
          <mat-list-item [matTooltip]="products['Integrate']" i18n-matTooltip>
            <div [matMenuTriggerFor]="appSwitcherMenu" class="item-content">
              <mat-icon>apps</mat-icon>
            </div>
          </mat-list-item>
        </mat-nav-list>

        <mat-nav-list>
          <a i18n-matTooltip
             mat-list-item
             matTooltip="Messages"
             routerLink="/messages"
            routerLinkActive="active"
          >
            <div class="item-content">
              <mat-icon>list_alt</mat-icon>
            </div>
          </a>
        </mat-nav-list>

        <div style="flex: 1"></div>

        <mat-nav-list class="wrapped-list">
          <mat-list-item (click)="openNotification()" i18n-matTooltip matTooltip="Notifications">
            <div class="item-content">
              <mat-icon>notifications</mat-icon>
              <div *ngIf="hasNotifications$ | async" class="visual-indicator">
                <div></div>
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>

        <div class="legal">
          <button (click)="srv.toggleState()" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>
    <!-- / CLOSED -->

  </mat-sidenav>

  <mat-sidenav-content>
    <navigation-toolbar></navigation-toolbar>
    <div class="router-wrapper">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>

<!-- APP SWITCHER MENU -->
<mat-menu #appSwitcherMenu="matMenu">
  <app-switcher></app-switcher>
</mat-menu>
<!-- / APP SWITCHER MENU -->
